const React = require('react');
const map = require('mn-utils/map');
const withState = require('../../../../utils/withState');
const setTitle = require('../../../../utils/setTitle');
const {
  LINK_DASHBOARD,
  LINK_START_STEP,
  LINK_START_FIRST,
} = require('../../../../constants/links');
const {
  Link,
  replaceLocation,
  pushLocation,
} = require('../../../../router');
const {
  apiV2KycGetStatus,
} = require('../../../../api/merchant/kyc');
const {
  account$,
  loadingAccount$,
} = require('../../../../emitters/account');
const {
  openPopupInfo,
} = require('../../../../emitters/popup');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');
const AppIcon = require('../../../icons/Lunu');

const ConfirmationDialogs = require('./components/ConfirmationDialogs');

const {
  signOut,
} = account$;


const STATUS_COMPLETED = 'completed';
const STEPS = [
  {
    name: 'Company',
    component: require('./steps/Step1'),
  },
  {
    name: 'Personal profile',
    component: require('./steps/Step2'),
  },
  {
    name: 'Business owners',
    component: require('./steps/Step3'),
  },
  {
    name: 'Supporting documents',
    component: require('./steps/Step4'),
  },
  {
    name: 'Bank details',
    component: require('./steps/Step5'),
  },
  {
    name: 'Finish',
    component: require('./steps/Step6'),
  },
];
const STEP_END = STEPS.length;


function getavailableStep(steps) {
  const stepsLength = steps.length;
  let i = 0;
  let item;
  for (;i < stepsLength; i++) {
    item = steps[i];
    if (!(item && item.completed)) {
      return i + 1;
    }
  }
  return stepsLength + 1;
}
function asDoc(doc) {
  return doc ? {
    fileId: doc.id,
    name: doc.file_name,
  } : null;
}

module.exports = withState((setState, self, onMount) => {
  let _handleChange;
  let _handleChangeRemove;

  function handleConfirmOK() {
    _handleChange();
    handleConfirmClose();
  }
  function handleConfirmClose() {
    setState({
      openConfirm: false,
    });
  }
  function handleOpenConfirm(handleChange) {
    _handleChange = handleChange;
    setState({
      openConfirm: true,
    });
  }
  function handleConfirmRemoveOK() {
    _handleChangeRemove();
    handleConfirmRemoveClose();
  }
  function handleConfirmRemoveClose() {
    setState({
      openConfirmRemove: false,
    });
  }
  function handleOpenConfirmRemove(handleChange) {
    _handleChangeRemove = handleChange;
    setState({
      openConfirmRemove: true,
    });
  }

  function checkStep() {
    setState({
      loading: true,
    });
    return apiV2KycGetStatus().finally((error, response) => {
      response = response || {};

      const verificationState = response.verification_state;
      if (verificationState === 'approved') {
        replaceLocation({
          path: LINK_DASHBOARD,
        });
        return;
      }

      const rejected = verificationState === 'rejected';

      const company = response.company || {};
      const profile = response.profile || {};
      const owner = response.owner || {};
      const doc = response.document || {};
      const bank = response.bank || {};

      const stepStates = [
        {
          ...(company.company || {}),
          completed: company.status === STATUS_COMPLETED,
          docBusinessRegistrationExtract:
            asDoc(company.business_registration_extract),
          docBusinessOperatingAddress:
            asDoc(company.business_operating_address),
          docShareHolderStructure:
            asDoc(company.share_holder_structure),
        },
        {
          ...(profile.profile || {}),
          completed: profile.status === STATUS_COMPLETED,
        },
        {
          list: owner.list || [],
          completed: owner.status === STATUS_COMPLETED,
        },
        {
          list: doc.list || [],
          completed: doc.status === STATUS_COMPLETED,
        },
        {
          ...(bank.bank || {}),
          completed: bank.status === STATUS_COMPLETED,
        },
        {
          message: response.message || '',
          rejected,
        },
      ];

      setState({
        rejected,
        loading: false,
        completed: response.status === STATUS_COMPLETED,
        stepStates,
        availableStep: getavailableStep(stepStates),
      });
    });
  }

  function handleSubmit() {
    openPopupInfo([
      'Data has been saved',
    ]);
    checkStep();
  }
  function handleNext() {
    const nextStep = parseInt(self.props.params.step || 1) + 1;
    nextStep <= self.state.availableStep && pushLocation({
      path: LINK_START_STEP + '/' + nextStep,
    });
  }
  function handleSubmitAndNext() {
    checkStep().then(handleNext);
  }

  onMount(checkStep);


  return (state, props) => {
    const {
      account,
    } = state;

    if (account && account.verified) {
      replaceLocation({
        path: LINK_DASHBOARD,
      });
      return null;
    }


    const {
      params,
    } = props;
    const currentStep = parseInt(params.step || 1);
    const index = currentStep - 1;
    const stepStates = state.stepStates || [];
    const stepState = stepStates[index] || {};
    const availableStep = state.availableStep;


    if (availableStep && availableStep < currentStep) {
      replaceLocation({
        path: LINK_START_STEP + '/' + availableStep,
      });
      return null;
    }

    const step = STEPS[index];
    if (!step) {
      replaceLocation({
        path: LINK_START_FIRST,
      });
      return null;
    }

    const Step = step.component;

    setTitle(step.name);


    return (
      <WrapperWithLoading
        className="sq w100%+270@m3 ov bgF ff$3 c0"
        loading={state.loading || state.loadingAccount}
        inner={{
          className: 'abs s',
          style: {
            left: 'max(50% - 600px, 0px)',
          },
        }}
      >
        <div>
          <div className="w1200 wmax ph15 h140 h80@m layoutRow fhaB fvaC">
            <a
              className="layoutRow fhaS fvaC tdN olN dn o70:h"
              onClick={signOut}
            >
              <AppIcon className="w128 mr20 rlv c0"/>
              <div className="c5B47FF fw3 f16 lh30 lts0em">
                Console
              </div>
            </a>
            <div className="layoutRow fhaS fvaC">
              <div
                className="pr15 f12 fw3 lh lts0em c0"
              >{account.username || ''}</div>
              <a
                className="f16 fw3 lh lts0em c5B47FF ttU dn o70:h"
                onClick={signOut}
              >log out</a>
            </div>
          </div>
        </div>
        <div className="abs shb st140 st80@m">
          <div className="abs svl ovx ovyA">
            <div className="w430 w310@m rlv hmin ov">
              <img
                className="dB abs sr st-30 w118"
                alt=""
                src={require('./assets/shadow.png')}
              />
              <div className="pv15 pt40 rlv">
                {map(STEPS, (item, index) => {
                  const step = index + 1;
                  const hasActive = step <= currentStep;
                  const hasCurrent = step == currentStep;
                  const hasEnabled = step <= availableStep;
                  if (step === STEP_END) {
                    if (availableStep < STEP_END) {
                      return null;
                    }
                  }
                  return (
                    <div
                      key={step}
                      className="pv15"
                    >
                      <Link
                        className={`layoutRow fhaS fvaC f23 fw3 lh34 cA3A7AC
                          f16@m lh@m rlv usN olN tdN dn crD ph15
                          (c0|o70:not[.current]:h!).active
                          cr.enabled:not[.current]@mouse
                          (c63676C|c43475C:h!).enabled:not[.active]
                          c5B47FF.current `
                          + (hasActive ? ' active' : '')
                          + (hasCurrent ? ' current' : '')
                          + (hasEnabled ? ' enabled' : '')}
                        href={
                          !hasEnabled || hasCurrent
                            ? null
                            : (LINK_START_STEP + step)
                        }
                      >
                        <img
                          className="dN dB<1.current abs sr6 st-24 st-29@m sr w106"
                          alt=""
                          src={require('./assets/shadow_arrow.png')}
                        />
                        <div
                          className="layoutRow fhaC fvaC sq(|min)27 sq(|min)24@m
                            bg5B47FF cF r f16 fw3 lh lts0em dn z-1 o0
                            (o100|z1)<1.active f14@m"
                        >{step}</div>
                        <div
                          className="pl16 pl10@m rlv"
                        >{item.name}</div>
                      </Link>
                    </div>
                  );
                })}
              </div>
              {state.rejected ? (
                <div
                  className="tl pl44 pl34@m pr20 f18 cF00 rlv z1 f14@m"
                >Your registration has been rejected</div>
              ) : null}
            </div>
          </div>
          <div className="abs sl430 sl270@m svr ovx ovyS">
            <div className="wmax770 layoutRow fhaE fvaS">
              <div className="wmax690 w pt50 pb50 ph15">
                <Step
                  defaultState={stepState}
                  disabledNext={currentStep >= availableStep}
                  onSubmit={handleSubmit}
                  onNext={handleNext}
                  onMount={checkStep}
                  handleSubmitAndNext={handleSubmitAndNext}
                  handleOpenConfirm={handleOpenConfirm}
                  handleOpenConfirmRemove={handleOpenConfirmRemove}
                />
                <ConfirmationDialogs
                  openConfirm={state.openConfirm || false}
                  onConfirmClose={handleConfirmClose}
                  onConfirmOK={handleConfirmOK}
                  openConfirmRemove={state.openConfirmRemove || false}
                  onConfirmRemoveClose={handleConfirmRemoveClose}
                  onConfirmRemoveOK={handleConfirmRemoveOK}
                />
              </div>
            </div>
          </div>
        </div>
      </WrapperWithLoading>
    );
  };
}, {
  loadingAccount: loadingAccount$,
  account: account$,
});
